<template>
  <div class="overlay" v-if="this.loaded">
    <div class="overlay_inner settings channel_list scrollable_popup">
      <section v-if="Object.keys(formData.linear_protocol).length">
        <div class="left">
          <p class="note"><translate>Lineární protokoly</translate></p>
        </div>
        <div class="right checkbox_group">
          <ul>
            <li v-for="item in formData.linear_protocol">
              <input type="checkbox"
                     :id="item.id+'_linear'"
                     :value="item.id"
                     v-model="entity.selected_linear_protocol_ids"
              >
              <label :for="item.id+'_linear'">{{item.name}}</label>
            </li>
          </ul>
        </div>
      </section>
      <p></p>
      <section v-if="Object.keys(formData.nonlinear_protocol).length">
        <div class="left">
          <p class="note"><translate>Nelineární protokoly</translate></p>
        </div>
        <div class="right checkbox_group">
          <ul>
            <li v-for="item in formData.nonlinear_protocol">
              <input type="checkbox"
                     :id="item.id+'_nonlinear'"
                     :value="item.id"
                     v-model="entity.selected_nonlinear_protocol_ids"
              >
              <label :for="item.id+'_nonlinear'">{{item.name}}</label>
            </li>
          </ul>
        </div>
      </section>
      <p></p>
      <section v-if="Object.keys(formData.nonlinear_protocol).length">
        <div class="left">
          <p class="note"><translate>Nastavení nelineárního obsahu</translate></p>
        </div>
        <div class="right">
          <div class="field_left">
            <p class="field">
              <input id="hastimeshift" name="hastimeshift" type="checkbox"
                     v-model="entity.nonlinear_settings.has_timeshift"
                     :disabled="!entity.selected_nonlinear_protocol_ids.length"
              >
              <label for="hastimeshift"
                     v-translate>Max. délka TimeShiftu</label>
              <input id="timeshiftoverride" name="timeshiftoverride" size="30" type="number"
                     v-model="entity.nonlinear_settings.timeshift_override"
                     :disabled="!entity.nonlinear_settings.has_timeshift || !entity.selected_nonlinear_protocol_ids.length > 0">
            </p>
            <p class="field">
              <input id="hascatchup" name="hascatchup" type="checkbox"
                     v-model="entity.nonlinear_settings.has_catchup"
                     :disabled="!entity.selected_nonlinear_protocol_ids.length"
              >
              <label for="hascatchup"
                     v-translate>Max. délka CatchUpu</label>
              <input id="catchupoverride" name="catchupoverride" size="30" type="number"
                     v-model="entity.nonlinear_settings.catchup_override"
                     :disabled="!entity.nonlinear_settings.has_catchup || !entity.selected_nonlinear_protocol_ids.length > 0">
            </p>
          </div>
          <div class="field_right">
            <p class="field">
              <input id="haspvr" name="haspvr" type="checkbox"
                     v-model="entity.nonlinear_settings.has_pvr"
                     :disabled="!entity.selected_nonlinear_protocol_ids.length"
              >
              <label for="haspvr"
                     v-translate>Max. délka uložení nahrávek</label>
              <input id="pvroverride" name="pvroverride" size="30" type="number"
                     v-model="entity.nonlinear_settings.pvr_override"
                     :disabled="!entity.nonlinear_settings.has_pvr || !entity.selected_nonlinear_protocol_ids.length">
            </p>
          </div>
        </div>
      </section>
      <p></p>
      <section>
        <div class="left">
          <p class="note"><translate>Profily kanálu</translate></p>
        </div>
        <div class="right checkbox_group">
          <ul>
            <li v-for="item in formData.profiles">
              <input type="checkbox"
                     :id="item.id+'_protocol'"
                     :value="item.id"
                     v-model="entity.selected_profile_ids"
              >
              <label :for="item.id+'_protocol'">{{item.name}}</label>
            </li>
          </ul>
        </div>
      </section>
      <p class="buttons">
        <a
            class="btn"
            @click.stop.prevent="emitAction"
            :class="{btn_inactive: !isValid}"
            v-translate>Hotovo</a>
      </p>
      <a class="btn btn_action btn_close" :title="'Zavřít' | translate" @click.stop.prevent="emitClose" v-translate>Zavřít</a>
    </div>
  </div>
</template>

<script>

import ListCheckboxInput from "@/components/common/ListCheckboxInput"
export default {
  name: "ContentSourceContentPopup",
  components: {
    ListCheckboxInput
  },
  props: {
    popupData: Object,
    idChannel: Number,
  },
  created(ContentSourceService){
    this.contentSourceService = ContentSourceService;
  },
  data(){
    return {
      entity: {
        selected_linear_protocol_ids: [],
        selected_nonlinear_protocol_ids: [],
        nonlinear_settings: {
          has_timeshift: false,
          has_catchup: false,
          has_pvr: false,
          timeshift_override: null,
          catchup_override: null,
          pvr_override: null
        },
        selected_profile_ids: [],
      },
      formData: {},
      isValid: false,
      loaded: false,
    }
  },
  methods: {
    validate(){
      if(this.entity.selected_nonlinear_protocol_ids.length > 0 && !(this.entity.nonlinear_settings.has_timeshift
          || this.entity.nonlinear_settings.has_catchup
          || this.entity.nonlinear_settings.has_pvr
      )){
        this.isValid = false;
      }else {
        this.isValid = ((this.entity.selected_linear_protocol_ids.length > 0
                || (this.entity.selected_nonlinear_protocol_ids.length > 0))
            && this.entity.selected_profile_ids.length > 0);
      }
    },

    init(id_content_source){
      this.contentSourceService.getContentSourceChannelData(id_content_source, {'id_channel': this.idChannel})
          .then((data) => {
            this.formData = data['data'];
            if(Object.keys(this.popupData).length !== 0){
              this.entity = this.popupData;
            }else{
              this.entity = {
                selected_linear_protocol_ids: this.formData.selected_linear_protocol_ids,
                selected_nonlinear_protocol_ids: this.formData.selected_nonlinear_protocol_ids,
                nonlinear_settings: this.formData.nonlinear_settings,
                selected_profile_ids: this.formData.selected_profile_ids,
              }
            }
            this.validate();
            this.loaded = true;
          })
    },
    emitAction() {
      if(this.isValid) {
        this.loaded = false;
        this.$emit('save-settings', this.entity);
      }
    },
    emitClose() {
      this.loaded = false;
      this.$emit('close-popup');
    },
  },
  watch:{
    entity:{
      handler: function(val, oldVal){
        this.validate();
        },
      deep: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/channels/ContentSourceContentPopup.vue